import React from 'react';
import ButtonAppNew from 'components/ButtonAppNew';
import IconAdd from 'images/others/button-add.svg';

const ButtonConnect = props => {
  return (
    <ButtonAppNew {...props} variant="outlined">
      <img src={IconAdd} alt="plus" />
      connect
    </ButtonAppNew>
  );
};

export default ButtonConnect;



// WEBPACK FOOTER //
// ./src/components/common/accounts/components/card/ButtonConnect.js